import { useState } from 'react';
import { Brain, ChevronDown, ChevronRight } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { cn } from '@/lib/utils';

/**
 * Collapsible "thinking" section. Defaults to closed; the body renders as
 * dim italic text inside a left-border block, matching AI Elements' look.
 */
export function Reasoning({
  children,
  defaultOpen = false,
  className,
}: {
  children: string;
  defaultOpen?: boolean;
  className?: string;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Collapsible
      open={open}
      onOpenChange={setOpen}
      className={cn('min-w-0 max-w-[88%] overflow-hidden rounded-md border border-border/50', className)}
    >
      <CollapsibleTrigger asChild>
        <button
          type="button"
          className="flex w-full items-center gap-1.5 px-3 py-1.5 text-left text-xs text-muted-foreground hover:text-foreground"
        >
          {open ? <ChevronDown className="size-3" /> : <ChevronRight className="size-3" />}
          <Brain className="size-3" />
          <span>thinking</span>
        </button>
      </CollapsibleTrigger>
      <CollapsibleContent className="border-t border-border/50 px-3 py-2">
        <div className="whitespace-pre-wrap text-xs italic text-muted-foreground">{children}</div>
      </CollapsibleContent>
    </Collapsible>
  );
}
